import { useState } from "react";
import { IoPricetagSharp } from "react-icons/io5";

function ProjectItemTag({ tagName }) {
  const [isHovered, setIsHovered] = useState(false);

  // Inline styles derived from the Tailwind CSS classes.
  // Note: Responsive styles (like md:*) and pseudo-classes (like hover:)
  // are not directly translatable. The hover effect is handled with state.
  const tagStyle = {
    display: "flex",
    background: "#ffebeew",
    alignItems: "center",
    gap: "0.25rem", // from gap-1
    border: "2px solid transparent", // from border-2 and border-northeastern-red
    borderRadius: "9999px", // from rounded-full
    padding: "0.125rem 0.25rem", // from py-0.5 and px-1
    cursor: "pointer",
    color: isHovered? "white":"#c93a40",
    transition: "background-color 150ms ease-in-out", // from transition-colors
    backgroundColor: isHovered ? "#c93a40" : "#FEE2E2", // from bg-northeastern-red-100 & hover:bg-northeastern-red-200
  };

  const iconStyle = {
    width: "0.75rem", // from size-3
    height: "0.75rem",
  };

  const textStyle = {
    fontFamily: "Lato, Helvetica, Arial, Lucida, sans-serif",
    fontSize: "0.75rem", 
    lineHeight: "1rem",
    fontWeight: "600",
  };

  return (
    <div
      style={tagStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IoPricetagSharp style={iconStyle} />
      <p style={textStyle}>{tagName}</p>
    </div>
  );
}

export default ProjectItemTag;
